module.exports = __webpack_public_path__ + "static/media/publicHolidaysSampleUpload.f4378690.xlsx";